<template>
  <div style="overflow: auto; height: 100%" id="currentTabPaneConsole" class="pdlr-12 pdtb-8 mglr-12">
    <div v-for="(item, index) in infoList" :key="index" class="mgb-8">
      <div class="console">
        <span :class="[item.type === 'error' ? 'msg-red' : 'msg', 'mgr-4']">{{ item.message }}</span>

        <div class="flex sql-tooltip mgl-8">
          <a-popover>
            <template slot="content">
              <span style="white-space: pre-wrap">执行时间：{{ timestamp2Date(item.startTime) }}</span
              ><br />
              <span style="white-space: pre-wrap">结束时间：{{ timestamp2Date(item.endTime) }}</span>
            </template>
            <span>{{item.execTime}}ms ( 执行 {{ item.escapeTime }} ms )</span>
          </a-popover>

          <div v-if="item.resultTabKey" class="flex">
            &nbsp;&nbsp;|&nbsp;&nbsp;
            <a
              class="disable-link"
              v-if="panes.findIndex((pane) => pane.key === item.resultTabKey) === -1"
              title="结果页已被关闭"
              >{{ item.resultTabKey }}</a
            >
            <a v-else class="sql-tooltip" @click="handleToResult(item.resultTabKey)">{{ item.resultTabKey }}</a>
          </div>
        </div>
      </div>
      <a-tag class="sql-content" :title="item.sql" @click="clickSql(item.sql)">{{ item.sql }}</a-tag>
    </div>
    <div style="margin-top: 48px"></div>
  </div>
</template>

<script>
import { timestamp2Date } from '@/utils/util'

export default {
  name: 'TabPaneConsole',
  components: {},
  props: {
    infoList: {
      type: Array,
      default: () => [],
    },
    panes: {
      type: Array,
      default: () => [],
    },
  },
  mounted() {
    const currentEl = document.getElementById('currentTabPaneConsole')
    if (currentEl) {
      currentEl.scrollTop = currentEl.scrollHeight
    }
    this.showSQL = this.infoList.map(() => false)
    this.showDuration = this.infoList.map(() => false)
  },
  watch: {
    infoList: {
      immediate: false,
      handler: function (nVal, oVal) {
        let append = nVal.length - oVal.length
        this.showSQL.push(...Array(append).fill(true))
        this.showDuration.push(...Array(append).fill(true))
      },
    },
  },
  data() {
    return { showSQL: [], showDuration: [] }
  },
  methods: {
    timestamp2Date,
    handleToResult(resultTabKey) {
      this.$emit('handleToResult', resultTabKey)
    },
    handleShowDuration(item, index) {
      let ori = this.showDuration[index]
      this.showDuration.splice(index, 1, !ori)
    },
    clickSql(sql) {
      this.$emit("clickSql",sql)
    }
  },
}
</script>

<style lang="less" scoped>
.console {
  display: flex;
  align-items: flex-end;
  line-height: 1;
  margin-bottom: 4px;
}
.msg {
  white-space: pre-wrap;
  color: #000000a6;
  font-weight: 500;
  font-size: 1.02rem;
  vertical-align: bottom;
}

.msg-red {
  font-weight: 400;
  font-size: 1.02rem;
  color: #e42b1e;
}
.tooltip-title {
  max-width: 500px;
  max-height: 300px;
  overflow: auto;
}

.sql-tooltip {
  white-space: pre-wrap;
  font-size: 11px;
  color: #999aaa;
}

.sql-content {
  white-space: pre-wrap;
  overflow: hidden;
  max-width: 500px;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-size: 11px;
  color: #999aaa;
  cursor: pointer;
}
</style>